const VideoHandler = {
    elements: {
        videoContainerClass: 'video-background',
        videoPlayingClass: 'video-background--playing',
        playButtonClass: 'video-background__toggle'
    },
    getVideos: function () {
        return document.querySelectorAll('.' + VideoHandler.elements.videoContainerClass + ' video');
    },
    getCookie: function(name) {

        var re = new RegExp(name + "=([^;]+)");
        var value = re.exec(document.cookie);
        return (value !== null) ? unescape(value[1]):null;

    },

    addPlayButton: function(video) {

        // Create: Play/Pause Button
        let playButton = document.createElement("button");
        playButton.setAttribute('class', VideoHandler.elements.playButtonClass);
        playButton.setAttribute('aria-label', 'Play');
        playButton.setAttribute('type', 'button');
        video.closest('.' + VideoHandler.elements.videoContainerClass).appendChild(playButton);

        let autoplay = video.getAttribute('autoplay');
        if (autoplay === "") {
            playButton.setAttribute('aria-pressed', 'true');
        } else {
            playButton.setAttribute('aria-pressed', 'false');
        }

        playButton.onclick = function() {
            if (playButton.closest('.' + VideoHandler.elements.videoContainerClass).classList.contains(VideoHandler.elements.videoPlayingClass)) {
                playButton.closest('.' + VideoHandler.elements.videoContainerClass).classList.remove(VideoHandler.elements.videoPlayingClass);
                playButton.closest('.' + VideoHandler.elements.videoContainerClass).querySelector('video').pause();
                playButton.setAttribute('aria-pressed', 'false');
                document.cookie = "backgroundVideoPaused=true; path=/";
            } else {
                playButton.closest('.' + VideoHandler.elements.videoContainerClass).classList.add(VideoHandler.elements.videoPlayingClass)
                playButton.closest('.' + VideoHandler.elements.videoContainerClass).querySelector('video').play();
                playButton.setAttribute('aria-pressed', 'true');
                document.cookie = "backgroundVideoPaused=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            }

        };
        return playButton;
    },
    init: function () {
        let videos = VideoHandler.getVideos();
        for (let i = 0; i < videos.length; i++) {
            let isPaused = VideoHandler.getCookie('backgroundVideoPaused');
            let autoplay = videos[i].getAttribute('autoplay');
            if(autoplay === "") {
                videos[i].closest('.' + VideoHandler.elements.videoContainerClass).classList.add(VideoHandler.elements.videoPlayingClass);
            }

            let playButton = VideoHandler.addPlayButton(videos[i]);

            let motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
            if (motionQuery.matches || isPaused ) {
                videos[i].pause();
                videos[i].closest('.' + VideoHandler.elements.videoContainerClass).classList.remove(VideoHandler.elements.videoPlayingClass);
                playButton.closest('.' + VideoHandler.elements.videoContainerClass).querySelector('.' + VideoHandler.elements.playButtonClass).setAttribute('aria-pressed', 'false');
            }
        }
    },
}

document.addEventListener(
    "DOMContentLoaded",
    function () {
        VideoHandler.init();

        const callback = function (mutationsList) {
            for (let i = 0, len = mutationsList.length; i < len; i++) {
                if (mutationsList[i].type == "childList") {
                    VideoHandler.init();
                    break;
                }
            }
        }

        const observer = new MutationObserver(callback);
        const config = {
            childList: true,
            subtree: false,
        }        
        if (document.getElementById("root") != null) {
            observer.observe(document.getElementById("root"), config)
        }
    },
    false
)
